// src/components/MuiYearPicker.jsx

import * as React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

/**
 * A standalone MUI Year Picker that works with a "YYYY" string state.
 */
export function YearPicker({ value, onChange }) {
    const handleYearChange = (newValue) => {
        if (newValue) {
            onChange(newValue.format('YYYY'));
        } else {
            onChange('');
        }
    };

    const dayjsValue = value ? dayjs(value) : null;

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                views={['year']}      // Only year view
                openTo="year"         // Start directly on year selection
                format="YYYY"         // Display format
                value={dayjsValue}
                onChange={handleYearChange}
                slotProps={{
                    textField: {
                        fullWidth: true,
                        variant: "outlined",
                    },
                }}
            />
        </LocalizationProvider>
    );
}
